<template>
  <span
    v-if="isText"
    :style="{'color':textColor,'padding':'0 8px'}"
  >{{ $slots.default[0].text }}</span>
  <el-tag
    v-else
    :style="{'border-color':borderColor,'color':textColor,'border-radius':'100px','padding':'0 8px', ...styleOptions}"
    :type="type"
    :closable="closable"
    :disable-transitions="disableTransitions"
    :hit="hit"
    :color="color"
    :size="size"
    :effect="effect"
    @click.stop="handleClick"
    @close="handleClose"
  > {{ $slots.default[0].text }}</el-tag>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    isText: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    disableTransitions: {
      type: Boolean,
      default: false
    },
    hit: {
      type: Boolean,
      default: false
    },
    scene: {
      type: String
    },
    size: {
      type: String,
      default: 'small'
    },
    effect: {
      type: String,
      default: 'light'
    },
    styleOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      color: '',
      textColor: '',
      borderColor: ''
    }
  },
  watch: {
    scene(val, newVal) {
      this.formatColor()
    }
  },
  created() {
    this.formatColor()
  },
  methods: {
    handleClose(event) {
      this.$emit('close', event)
    },
    handleClick(event) {
      this.$emit('click', event)
    },
    formatColor() {
      if (this.effect == 'light') {
        if (this.scene == 'info') {
          this.color = '#dbe9ec'
          this.textColor = '#4D939F'
        }
        if (this.scene == 'start') {
          this.color = '#b6bdc3'
          this.textColor = '#5A6770'
        }
        if (this.scene == 'wait') {
          this.color = '#f7ebd8'
          this.textColor = '#FF9501'
        }
        if (this.scene == 'primary') {
          this.color = '#cfe4f7'
          this.textColor = '#557FA6'
        }
        if (this.scene == 'success') {
          this.color = '#bbf0cd'
          this.textColor = '#069737'
        }
        if (this.scene == 'danger') {
          this.color = '#f7cfd8'
          this.textColor = '#EB426B'
        }
        if (this.scene == 'finish') {
          this.color = '#f2f2f3'
          this.textColor = '#5A6770'
        }
        if (this.scene == 'cancel') {
          this.color = '#f2f2f3'
          this.textColor = '#aaaaaa'
        }
        this.borderColor = this.textColor
      }
      if (this.effect == 'dark') {
        if (this.scene == 'info') {
          this.color = '#dbe9ec'
          this.textColor = '#4D939F'
        }
        if (this.scene == 'start') {
          this.color = '#5a6770'
          this.textColor = '#fff'
        }
        if (this.scene == 'wait') {
          this.color = '#ff9501'
          this.textColor = '#fff'
        }
        if (this.scene == 'primary') {
          this.color = '#52aaf2'
          this.textColor = '#fff'
        }
        if (this.scene == 'success') {
          this.color = '#19c758'
          this.textColor = '#fff'
        }
        if (this.scene == 'danger') {
          this.color = '#eb426b'
          this.textColor = '#fff'
        }
        if (this.scene == 'finish') {
          this.color = '#f2f2f3'
          this.textColor = '#5A6770'
        }
        if (this.scene == 'cancel') {
          this.color = '#f2f2f3'
          this.textColor = '#aaaaaa'
        }
        this.borderColor = this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
